import styled from "styled-components";
import * as UscCashPrice from "../price/UscCashPrice.styles";

export const PriceBreakdown = styled.div`
    overflow-y: auto;
`;

export const RetailPriceList = styled.ul`
    margin: 0;
    padding: 0;
    list-style: none;

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        width: 100%;
        padding-block-end: calc(var(--spacing-3) / 2);

        @supports not (padding-block: 0) {
            &:nth-last-child(1) {
                padding-bottom: calc(var(--spacing-3) / 2);
            }
        }
    }

    ${UscCashPrice.Cash} {
        font-size: 1.3rem;
        line-height: 1.5;
    }
`;
